<ng-container *transloco="let t;">
  <ng-container *ngIf="employee">
    <div style="margin-bottom: 50px">    
      <h1> {{ t('home.greeting') }} {{employee.firstName}} {{employee.lastName}}</h1>
    </div>
    
    <ng-container *permissionIf="'Permissions.SchedulerItems.Search'">
      <kendo-scheduler
        [events]="schedulerEvents$ | async"
        [selectedDate]="selectedDate"
        (dateChange)="onDateChange($event)"
        [workDayStart]="(tenantSettings$ | async)?.startMorningWorkTime"
        [workDayEnd]="(tenantSettings$ | async)?.endAfternoonWorkTime"
        [showWorkHours]="true"
        eventHeight=120
        [columnWidth]="50"
        [slotClass]="setSlotBackgroundColor"
        [eventStyles]="setBorderColor"
        (schedulerResize)="onSchedulerResize($event)"
        [loading]="isLoading"
      >

      <ng-template
          kendoSchedulerToolbarTemplate
          let-selectedDate="selectedDate"
          class="k-scheduler-toolbar"
          let-selectedView="selectedView"
        >

          <div kendoSchedulerToolbarNavigation></div>

          <div>KW {{weekNumber}}</div>
          <div *ngIf="selectedView.name == 'timelineMonth'"> - {{weekNumberEnd}}</div>

          <span class="k-spacer"></span>

          <div
            kendoSchedulerToolbarViewSelector
            class="k-scheduler-views-wrapper"
            [displayMode]="toolbarWidth < 960 ? 'compact' : 'default'"
          ></div>

        </ng-template>
      
        <kendo-scheduler-day-view
          slotDuration="60"
          slotDivisions="1"
        ></kendo-scheduler-day-view>

        <kendo-scheduler-week-view
        slotDuration="60"
        slotDivisions="1"
        ></kendo-scheduler-week-view>

        <!-- Same date header as the main planner (scheduler-shared) -->
        <ng-template kendoSchedulerDateHeaderTemplate let-date="date">
          <strong>{{ date | date: "EEEEEE dd.MM." }}</strong>
        </ng-template>

        <kendo-scheduler-messages
          [calendarToday]="t('scheduler-shared.calendarToday')"
          [today]="t('scheduler-shared.today')"
          [showWorkDay]="t('scheduler-shared.showWorkDay')"
          [showFullDay]="t('scheduler-shared.showFullDay')"
          [nextTitle]="t('scheduler-shared.nextTitle')"
          [previousTitle]="t('scheduler-shared.previousTitle')"
          [dayViewTitle]="t('scheduler-shared.dayViewTitle')"
          [weekViewTitle]="t('scheduler-shared.weekViewTitle')"
        >
        </kendo-scheduler-messages>

        <!-- All Day Events -->
        <ng-template 
          kendoSchedulerAllDayEventTemplate 
          let-event="event" 
          let-resources="resources"

        >
          <div class="schedulerItem">
            <div class="content">
              <div 
              class="eventTitle">
                  <ng-container *ngIf="event.dataItem.assignment?.id">
                    <p>
                      <a [routerLink]="['/assignment', event.dataItem.assignment.id]">
                        {{ event.dataItem.assignment?.title }} {{" | "}} {{ event.dataItem.assignment?.internalNumber }} 
                        <kendo-icon name="hyperlink-open" themeColor="secondary"></kendo-icon>
                      </a>
                    </p>
                  </ng-container>
                  <p>
                    <strong>
                      {{ event.title }}
                    </strong>
                  </p>
                  <p>{{event.dataItem.description}}</p>
                  <ng-container *ngFor="let ressource of event.dataItem.ressources; last as isLast">
                    {{ressource.name}}{{!isLast ? ", " : null}}
                  </ng-container>
              </div>
            </div>
          </div>
        </ng-template>

        <!-- regular Events -->
        <ng-template
            kendoSchedulerEventTemplate
            let-event="event"
            let-resources="resources"
          >
            <div class="schedulerItem">
              <div class="content">
                <div 
                class="eventTitle">
                    <ng-container *ngIf="event.dataItem.assignment?.id">
                      <p>
                        <a [routerLink]="['/assignment', event.dataItem.assignment.id]">
                          {{ event.dataItem.assignment?.title }} {{" | "}} {{ event.dataItem.assignment?.internalNumber }} 
                          <kendo-icon name="hyperlink-open" themeColor="secondary"></kendo-icon>
                        </a>
                      </p>
                    </ng-container>
                    <strong>
                      {{ event.title }} 
                    </strong>
                    <p>{{event.dataItem.description}}</p>
                    <ng-container *ngFor="let ressource of event.dataItem.ressources">
                      <p>{{ressource.name}}</p>
                    </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
      </kendo-scheduler>
    </ng-container>

    <ng-container *permissionIfNot="'Permissions.SchedulerItems.Search'">
      <!-- Add Dashboard Widget for Assignment Module -->
    </ng-container>
  </ng-container>
</ng-container>